import React from "react";
import Sidebar from "../components/UI/Sidebar";
import Header from "../components/UI/Header"; // Import the Header

const MainLayout = ({ children }) => {
  return (

    // previous code.
    // due to the flex-grow the side bar was changing size based on the main content
    <div className="flex flex-col md:flex-row bg-[#eff3f8] min-h-screen">
      {/* Sidebar Section */}
      <div className="h-auto shadow"> 
        <Sidebar />
      </div>
      {/* </div>

      {/* Main Content Section */}
      <div className="flex-grow flex flex-col overflow-hidden">
        {/* Header Section */}
        <div className="z-20">
          <Header />
          <div className="md:hidden block">
            <Sidebar />
          </div>
        </div>
          

        {/* Main Content */}
        {/* added  h-20 and overflow-auto to stop extending main tag height */}
        <main className="flex-grow h-20 overflow-auto dark:bg-black bg-[#F9FAFB] shadow-sm">
          {children}
        </main>
      </div>
    </div>

    // new code for mobile responsive
    // <div className="flex flex-col md:flex-row bg-gray-50 min-h-screen">
    //   {/* Sidebar Section - hidden on small screens, toggle with a button if needed */}
    //   {/* <div className="hidden md:block"> */}
    //     <Sidebar />
    //   {/* </div> */}

    //   {/* Main Content Section */}
    //   <div className="flex-grow flex flex-col">
    //     {/* Header Section */}
    //     <Header />

    //     {/* Main Content */}
    //     <main className="flex-grow bg-gradient-to-r from-blue-100 to-gray-100 rounded-lg shadow-sm md:p-4 px-1 py-2">
    //       {children}
    //     </main>
    //   </div>
    // </div>


    // updated code
    // this code keeps the sidebar consistent.
    // <div className="flex bg-gray-50 h-screen">
    //   {/* Sidebar Section */}
    //   <div className="w-64 h-screen">
    //     <Sidebar />
    //   </div>

    //   {/* Main Content Section */}
    //   <div className="flex-1 flex flex-col min-h-screen">
    //     {/* Header Section */}
    //     <Header />

    //     {/* Main Content */}
    //     <main className="flex-1 bg-gradient-to-r from-blue-100 to-gray-100 rounded-lg shadow-sm px-4 pt-4">
    //       {children}
    //     </main>
    //   </div>
    // </div>
  );
};

export default MainLayout;
